import React, { useState, useEffect } from 'react';
import { getActiveClasses, getInvoices} from './studentApi';

const Lessons = () => {
  const [activeClasses, setActiveClasses] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [classes, setClasses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    pageSize: 20,
    currentPage: 1
  });

  const fetchData = async (page = 1) => {
    try {
      setLoading(true);
      const [classesData, invoicesResponse] = await Promise.all([
        getActiveClasses(),
        getInvoices(page)
      ]);
      setActiveClasses(classesData);
      setInvoices(invoicesResponse.invoices);
      setPagination(invoicesResponse.pagination);
    } catch (err) {
      setError('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);


  if (loading) {
    return <div className="container mx-auto p-4 text-center">Loading...</div>;
  }

  if (error) {
    return <div className="container mx-auto p-4 text-center text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Class Management</h1>

      {/* Active Classes Table */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Active Classes</h2>
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4 border-b">Tutor Name</th>
              <th className="py-2 px-4 border-b">Subject</th>
              <th className="py-2 px-4 border-b">Hours Completed</th>
              <th className="py-2 px-4 border-b">Total Hours</th>
            </tr>
          </thead>
          <tbody>
            {activeClasses.map((classItem) => (
              <tr key={classItem.id}>
                <td className="py-2 px-4">{classItem.studentName}</td>
                <td className="py-2 px-4">{classItem.subject}</td>
                <td className="py-2 px-4">{classItem.totalHours - classItem.remainingHours}</td>
                <td className="py-2 px-4">{classItem.totalHours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Invoices Table */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Sessions</h2>
        <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-2 px-4 border-b">Date</th>
              <th className="py-2 px-4 border-b">Subject</th>
              <th className="py-2 px-4 border-b">Duration (Hours)</th>
              <th className="py-2 px-4 border-b">Notes</th>
              <th className="py-2 px-4 border-b">Actions</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map((invoice) => (
              <tr key={invoice.id} className="border-b hover:bg-gray-50">
                <td className="py-2 px-4">{new Date(invoice.date).toLocaleDateString()}</td>
                <td className="py-2 px-4">{invoice.subject}</td>
                <td className="py-2 px-4">{invoice.duration}</td>
                <td className="py-2 px-4">{invoice.notes}</td>
              </tr>
            ))}
          </tbody>
        </table>
        
        {/* Pagination */}
        {pagination.count > 0 && (
          <div className="mt-4 flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Showing {((currentPage - 1) * pagination.pageSize) + 1} to {Math.min(currentPage * pagination.pageSize, pagination.count)} of {pagination.count} invoices
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={!pagination.previous || loading}
                className="px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Previous
              </button>
              <span className="px-4 py-2 text-sm text-gray-700">
                Page {currentPage} of {Math.ceil(pagination.count / pagination.pageSize)}
              </span>
              <button
                onClick={() => setCurrentPage(prev => prev + 1)}
                disabled={!pagination.next || loading}
                className="px-4 py-2 border border-gray-300 rounded-md bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Lessons;
